<div class="cx-cart-item">
  <!-- Item Start Outlet -->
  <ng-template [cxOutlet]="CartOutlets.ITEM">
    <div [ngClass]="compact ? 'cx-compact row' : 'row'">
      <!-- Item Image -->
      <div class="col-2 cx-image-container">
        <a [routerLink]="{ cxRoute: 'product', params: customItem.product } | cxUrl" cxModal="dismiss" tabindex="-1">
          <cx-media [container]="customItem.product.images?.PRIMARY" format="cartIcon"></cx-media>
        </a>
      </div>

      <!-- Item Information -->
      <div class="cx-info col-10">
        <div class="cx-info-container row">
          <!-- Item Description -->
          <div [ngClass]="compact ? '' : ' col-md'">
            @if (customItem.product.name) {
              <div class="cx-name">
                <a
                  class="cx-link"
                  [routerLink]="{ cxRoute: 'product', params: customItem.product } | cxUrl"
                  cxModal="dismiss"
                  >{{ customItem.product.name }}</a
                  >
                </div>
              }
              @if (customItem.product.code) {
                <div class="cx-code">
                  {{ 'cartItems.id' | cxTranslate }} {{ customItem.product.code }}
                </div>
              }

              <!-- Item Details Outlet -->
              <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"> </ng-template>

              <!-- Variants -->
              @if (customItem.product.baseOptions?.length) {
                @for (variant of customItem.product.baseOptions[0]?.selected?.variantOptionQualifiers; track variant) {
                  <div
                    class="cx-property"
                    >
                    @if (variant.name && variant.value) {
                      <div class="cx-label">
                        {{ variant.name }}: {{ variant.value }}
                      </div>
                    }
                  </div>
                }
              }
            </div>

            <!-- Item Quantity -->
            <div class="cx-total" [ngClass]="compact ? '' : ' col-auto'">
              <div
                class="cx-label"
                [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
                placement="left"
                title="{{ 'cartItems.quantityTitle' | cxTranslate }}"
                >
                {{ 'cartItems.quantity' | cxTranslate }}
              </div>
              <div class="cx-value">
                {{ customItem.quantitySelected }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
